document.addEventListener("DOMContentLoaded", function(){

  const menuButton = document.querySelector(".pb-menu-btn");

  if(menuButton){

    menuButton.addEventListener("click", function(){

      const menuDrawer = document.querySelector(
        "header-drawer summary"
      );

      if(menuDrawer){
        menuDrawer.click();
      }

    });

  }

});